import { Alert } from '@mui/material';

const InfoAlert = ({ children, sx, ...props }) => (
  <Alert
    severity="info"
    sx={{
      alignItems: 'flex-start',
      backgroundColor: 'rgba(135, 200, 224, 0.12)',
      border: '1px solid rgba(135, 200, 224, 0.28)',
      color: '#D7EAF2',
      borderRadius: '8px',
      '& .MuiAlert-icon': {
        color: '#87C8E0',
      },
      ...sx,
    }}
    {...props}>
    {children}
  </Alert>
);

export default InfoAlert;
